export default __webpack_public_path__ + "static/media/up-down.11bcde51.svg";